import React, {useEffect} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {setAssignQuotePopupCustomer} from "../../../actions/assignPopupFunctions";
import AssignQuoteVirtualizedList from "./assignQuoteVirtualizedList";
import {customerInterface} from "./assignQuoteInterfaces";
import AssignPopupContext from './assignPopupContext';

const AssignQuoteCustomersList = (props) => {

  const {customersList, setAssignQuotePopupCustomer, assignQuotePopupCustomer, userInfo, contentDimensions, changeContext} = props;

  useEffect(() => {
    if (userInfo && userInfo.email && !assignQuotePopupCustomer) {
      const customerSelected = customersList.find(customer => customer.email === userInfo.email);
      if (customerSelected) {
        setAssignQuotePopupCustomer(customerSelected);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo.email]);

  const handleCustomerClick = (customerSelected) => {
    setAssignQuotePopupCustomer(customerSelected);
    changeContext({customerError: ""})
  }

  return (
    <AssignPopupContext.Consumer>
      {/*{({context, setContext}) => (*/}
      {({customerError}) => (
        <AssignQuoteVirtualizedList
          contentDimensions={contentDimensions}
          renderList={customersList}
          activeEntity={assignQuotePopupCustomer}
          selectEntity={handleCustomerClick}
          noEntitiesFound="assignPopup.noCustomersFound"
          title="assignPopup.customersTitle"
          errorMessage={customerError}
        />
      )}
    </AssignPopupContext.Consumer>
  )
};

AssignQuoteCustomersList.propTypes = {
  customersList: PropTypes.arrayOf(PropTypes.shape(customerInterface)).isRequired,
  assignQuotePopupCustomer: PropTypes.shape(customerInterface),
  contentDimensions: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
}

const mapStateToProps = (store) => {
  return {
    assignQuotePopupCustomer: store.assignQuoteState.assignQuotePopupCustomer,
    userInfo: store.userState.userInfo,
  };
};

const mapDispatchToProps = {
  setAssignQuotePopupCustomer
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignQuoteCustomersList)

